module.exports = __webpack_public_path__ + "static/ANTAH-7809f9f7ce6a81256d85a4472d34fd24.jpg";